import { string } from 'yup';

const REGEX_CITY_NAME = /^([a-zA-Z\u0080-\u024F']+(?:\. |-| |'))*[a-zA-Z\u0080-\u024F]*$/;
const errorMessage = 'Dit veld bevat invalide waarden';

const cityName = string().matches(REGEX_CITY_NAME, errorMessage);

export default cityName;
